export const COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  TARGETING: 'C0004',
  SOCIAL_MEDIA: 'C0005',
  STACK_42: 'V2STACK42'
}

export const MAIN_COOKIE_CATEGORY_VALUES = [
  COOKIE_CATEGORY.STRICTLY_NECESSARY,
  COOKIE_CATEGORY.PERFORMANCE,
  COOKIE_CATEGORY.FUNCTIONAL,
  COOKIE_CATEGORY.TARGETING,
  COOKIE_CATEGORY.SOCIAL_MEDIA
]

export const COOKIE_ENTITY_TYPE = {}

/**
 * Full list of prior blocked services
 */
export const REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE = {}

export const OPTANON_CONSENT_COOKIE_NAME = 'OptanonConsent'
export const OPTANON_ALERT_BOX_CLOSED_COOKIE_NAME = 'OptanonAlertBoxClosed'

export const HANDLER_TYPE = {
  GLOBAL: 'global',
  LOCAL: 'local'
}

export const HANDLER_TYPE_BY_ENTITY_TYPE = {}

export const ONETRUST_POPUP_WRAPPER_ID = 'onetrust-consent-sdk'
